import { useState, useRef } from 'react';
import { v4 as uuidV4 } from 'uuid';
/**
 * useChatbotState - Hook to manage chatbot state
 * @public
 */
export const useChatbotState = props => {
  const {
    submitChatMessagesPayload,
    componentVersion
  } = props;
  const telemetrySessionIdPart = uuidV4();
  const telemetrySessionId = submitChatMessagesPayload.cguid ? `${submitChatMessagesPayload.cguid}-${telemetrySessionIdPart}` : submitChatMessagesPayload.rguid;
  const [loadMoreMessages, setLoadMoreMessages] = useState(false);
  const [lastPromptId, setLastPromptId] = useState('');
  const audioPlayerRef = useRef(null);
  return {
    telemetrySessionId,
    audioPlayerRef,
    loadMoreMessages,
    setLoadMoreMessages,
    lastPromptId,
    setLastPromptId,
    componentVersion
  };
};